import React, { Component } from "react";
import { reverseParseTextView } from "./createRender";
import Footer from "../exercise/Footer";

const $ = require("$");
const MathQuill = require("MathQuill");

const MQ = MathQuill.getInterface(2);

class Question extends Component {
  constructor(props) {
    super(props);
  }

  createHtml = (str) => ({ __html: str ? str : `&nbsp;` });

  render() {
    let originData = this.props.data;
    const { num, index } = this.props;
    let data = {
        content: "unknown",
    };
    try {
      data = JSON.parse(originData.stem);
      debugger
    } catch (error) {}
    return (
      <div className="box-exercise" ref={"viewer"}>
        <div className="exercise-content">
          {num !== "undefined" && (
            <div className="exercise-num">
              <p className="math_text">
                {index || index === 0
                  ? `${index + 1} - ${num + 1}`
                  : `${num + 1}、`}
              </p>
            </div>
          )}
          <div
            className="exercise-con"
            dangerouslySetInnerHTML={this.createHtml(`<p class="math_guide">${data.content}</p><img src='${data.image}' width="324px"></img>`)}
          />
        </div>
        <div className="exercise-footer">
          <div className="footer-show relative">
            <Footer
              {...this.props}
              obj={originData}
              subject={this.props.data.subject}
            ></Footer>
          </div>
        </div>
      </div>
    );
  }
}

export default Question;



// WEBPACK FOOTER //
// ./src/entry_question_editor/question/scratch/viewForView.js